import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Feedback = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.078 0H9.02A8.985 8.985 0 0 0 0 9.025v15.642a8.985 8.985 0 0 0 9.02 9.025h3.007c1.603 0 3.007 1.304 3.007 3.008v5.215c0 1.804 2.104 2.707 3.407 1.604l10.223-8.924c.2-.201.4-.301.701-.401.401-.201.802-.301 1.203-.301h2.506c5.211 0 9.621-3.71 10.724-8.624v-.2c.2-.702.2-1.505.2-2.307V9.025C44.098 4.01 40.09 0 35.078 0Zm6.916 22.662c0 .602-.1 1.203-.2 1.805-.903 4.01-4.41 7.12-8.72 7.12h-2.506c-.701 0-1.503.2-2.105.5-.4.201-.801.402-1.202.703l-10.123 8.924V36.6c0-2.808-2.305-5.014-5.01-5.014H9.12c-3.808 0-6.915-3.108-6.915-6.919V9.025c0-3.81 3.107-6.92 6.915-6.92h26.058c3.809 0 6.916 3.11 6.916 6.92v13.637h-.1Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m32.272 15.843-4.911 3.81 1.704 5.917c.3 1.103-.902 1.805-1.704 1.303l-5.312-3.409-5.211 3.41c-.902.601-2.005-.301-1.704-1.204l1.704-5.916-4.911-3.81c-.902-.702-.401-2.006.601-2.006l6.314-.3 2.205-5.716c.2-.502.701-.702 1.102-.702.401 0 .902.2 1.103.702l2.205 5.715 6.314.301c.501 0 .902.401 1.002.802 0 .301-.1.803-.501 1.103Z"
  }));
});
Feedback.displayName = 'Feedback';
Feedback.defaultProps = {
  'aria-label': 'Feedback'
};
export default Feedback;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Feedback.js
// module id = 3158
// module chunks = 11